import { useAuth } from "../../contexts/AuthContext";
import { useHistory } from "react-router-dom";

export default function Dashboard() {
  const { currentUser, isAdmin } = useAuth();
  const history = useHistory();

  if (!isAdmin || !currentUser) {
    return "Ошибка";
  } else {
    history.push("/admin/contracts");
  }

  return <></>;
}
